<template>
  <div class="tch_router_content">
    <router-view
      ref="childRouter"
    ></router-view>
  </div>
</template>

<script>
import vm from "@/components/borther";
export default {
//   props: {
//     datas: {
//       type: Object,
//     },
//     ClassProjectInfo: {
//       type: Object,
//     },
//     // 班级详情统计
//     ClassDetailTotalData: {
//       type: Object,
//     },
//   },
  data() {
    return {};
  },
  methods: {
    // 监听接口
    callCreateFn() {
      vm.$on("callCreateFn", () => {
        // 调用子路由方法
        this.$refs.childRouter.createFn();
      });
    },
  },
  created() {
    // this.$emit("createFn");
    this.callCreateFn();
  },
};
</script>
 
<style lang = "less" scoped>
.tch_router_content {
  /* background-color: #fff; */
}
</style>